export const EXTRA_NOTE_LIST_TEMPLATE = ['家屬確認同意平台規範'];
